const integrations = [
  {
    path: 'integrations',
    name: 'integrations.dashboard',
    component: () =>
      import(
        /* webpackChunkName: 'integrations' */
        '@integrations/pages/dashboard'
      ),
    meta: {
      title: {
        code: 'integrations.breadcrumb.title'
      }
    }
  },
  {
    path: 'integrations/settings',
    // component: View,
    component: () =>
      import(/* webpackChunkName: "integrations" */ '@core/layouts/integrations-tabs'),
    children: [
      {
        path: 'auth',
        name: 'integrations.tabs.auth',
        meta: {
          title: { code: 'integrations.breadcrumb.auth.index' }
        },
        component: () =>
          import(/* webpackChunkName: "integrations" */ '@integrations/pages/integration-auth.vue')
      },
      {
        path: 'cases',
        name: 'integrations.tabs.cases',
        meta: {
          title: { code: 'integrations.breadcrumb.cases.index' }
        },
        component: () =>
          import(/* webpackChunkName: "integrations" */ '@integrations/pages/integration-cases.vue')
      },
      {
        path: 'users',
        name: 'integrations.tabs.users',
        meta: {
          title: { code: 'integrations.breadcrumb.users.index' }
        },
        component: () =>
          import(/* webpackChunkName: "integrations" */ '@integrations/pages/integration-users.vue')
      },
      {
        path: 'numbers',
        name: 'integrations.tabs.numbers',
        meta: {
          title: { code: 'integrations.breadcrumb.numbers.index' }
        },
        component: () =>
          import(
            /* webpackChunkName: "integrations" */ '@integrations/pages/integration-numbers.vue'
          )
      }
    ]
  }
];
export { integrations };
